import { z } from 'zod'

/**
 * Single chat message in the conversation history sent to the backend.
 * Mirrors the OpenAI/OpenRouter chat message shape.
 */
export const ChatHistoryMessageSchema = z.object({
  role: z.enum(['user', 'assistant', 'system']),
  content: z.string(),
})

export type ChatHistoryMessage = z.infer<typeof ChatHistoryMessageSchema>

/**
 * POST /api/chat request body schema.
 */
export const ChatRequestSchema = z.object({
  message: z.string().min(1, 'message is required'),
  history: z.array(ChatHistoryMessageSchema).default([]),
})

export type ChatRequest = z.infer<typeof ChatRequestSchema>

/**
 * POST /api/chat response body schema.
 */
export const ChatResponseSchema = z.object({
  response: z.string(),
  timestamp: z.string(),
})

export type ChatResponse = z.infer<typeof ChatResponseSchema>

/**
 * Error payload returned on /api/chat failures.
 */
export const ChatErrorSchema = z.object({
  error: z.string(),
  details: z.string().optional(),
})

export type ChatError = z.infer<typeof ChatErrorSchema>
